import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { ReferenceRateValue } from 'src/features/referenceRateValues/utils/types';
import { ReferenceRateValueFormSchemaValues } from 'src/features/referenceRateValues/utils/formSchema';

const RESOURCE = '/subscriptions/reference-rate/:referenceRateId/reference-rate-value/';

type MutationFnType = typeof mutationFn;

interface DTO extends ReferenceRateValueFormSchemaValues {
    referenceRateId: string;
}

// The parent rate comes from the URL and must not be in the body.
const mutationFn = ({ referenceRateId, ...data }: DTO): Promise<ReferenceRateValue> => {
    return axios.post(formatResourcePath(RESOURCE, { referenceRateId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateReferenceRateValue };
